import React, { useState, useEffect } from 'react';
import ActionButtonCard from '../Button/ActionButtonCard';
import RenderizarFoto from '../Utils/RenderizarFoto';
import Swal from 'sweetalert2'
import { useProvider } from '../../context/MenuProvider'; // Importa o contexto do Menu
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

const Perfil = () => {
  const { auth, site, getDeviceInfo } = useProvider();
  const info = getDeviceInfo();
  const [empresa, setEmpresa] = useState(auth?.empresa);

  return (
    <>
      <div className="row mb-1">
        <div className="col text-end">
            <div className="fs-3">{empresa?.nome_da_loja}</div>
            <div id="infoBackup">
              <div className="text-muted small">{`${auth?.backup?.data_ultimo ? `Último backup ${dayjs(auth?.backup?.data_ultimo).format("dddd DD/MMM [às] HH:mm")}` : "Nunca fez backup"}`}</div>
              <div className="text-muted small">{auth?.email}</div>
            </div>
        </div>
        <div className="col-auto">
          <RenderizarFoto src={`https://${site?.domain}${empresa?.logomarca}`} />
        </div>
      </div>
    </>
  );
};

export default Perfil;